<template>
  <section class="">
    <Modal
      v-model:show="isEdit"
      class="modal-alert"
      @close="isEdit = false"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('profile.paymentMethod.editTitle') }}
        </h5>
      </template>

      <div
        v-loading="isLoadingPaymentMethod"
        class="tw-grid tw-grid-cols-12 tw-gap-y-16"
      >
        <div class="tw-col-span-12">
          <UiSelect
            v-model="form.site_payment_method_id"
            v-model:error="errors_.site_payment_method_id"
            :label="$t('profile.paymentMethod.paymentMethod')"
            :placeholder="$t('profile.generalInfo.notSpecified')"
            :list="paymentMethodOptions"
            is-search
            error-clear-on-change
            @change="errors_.payment_method = ''"
          />
          <div
            v-if="getSelectedPaymentMethodDescription"
            class="profile__payment-method-info"
          >
            <span
              v-for="(line, i) of getSelectedPaymentMethodDescription.split('\n')"
              :key="i"
            >
              {{ line }}<br>
            </span>
          </div>
        </div>
        <div class="tw-col-span-12">
          <UiInput
            v-model="form.payment_wallet"
            v-model:error="errors_.payment_wallet"
            class="mb-8"
            :label="$t('profile.paymentMethod.walletNumber')"
            :placeholder="wallet_placeholder"
            error-clear-on-change
          />
        </div>
      </div>
      
      <template v-slot:footer>
        <div class="!tw-flex !tw-justify-end !tw-w-full mt-8 mr-0">
          <button
            class="btn btn-outline-primary btn-sm btn__back"
            @click="close"
          >
            {{ $t('profile.buttons.cancel') }}
          </button>
          <button
            class="btn btn-primary btn-sm ml-16"
            :disabled="isLoading"
            @click="save"
          >
            {{ $t('profile.buttons.save') }}
          </button>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { Modal } from '@/components';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      isEdit: false,
      isLoadingPaymentMethod: false,
      paymentMethods: [],
      form: {},
      isLoading: false,
      errors_: {},
    };
  },
  computed: {
    paymentMethodOptions() {
      return [
        ...this.paymentMethods.map((el) => ({ ...el, text: el.name })),
      ];
    },
    getSelectedPaymentMethodDescription() {
      if (this.form.site_payment_method_id === undefined) return null;
      const findSelectMethod = this.paymentMethods.find((pm) => pm.id === this.form.site_payment_method_id);
      return findSelectMethod?.description || null;
    },

    wallet_placeholder() {
      if (this.form.site_payment_method_id) {
        return this.$store.state.misc.paymentMethods
          .find((e) => e.id === this.form.site_payment_method_id).wallet_placeholder;
      }
      return this.$t('profile.generalInfo.notSpecified');
    },
  },
  watch: {
    form(v) {
      if (v.payment_method === 'btc' || v.payment_method === 'bank_transfer') {
        this.form.payment_method = this.form.payment_method_name;
      }
    },
    '$i18n.locale': function () {
      this.$store.dispatch('getPaymentMethods');
    },
  },

  methods: {
    getPaymentMethod(currencyCode = this.$store.state.payments.currencyCode) {
      this.isLoadingPaymentMethod = true;
      return this.$api.getPaymentMethods({ currency_code: currencyCode })
        .then((res) => this.paymentMethods = res.payload)
        .finally(() => this.isLoadingPaymentMethod = false);
    },
    open(data) {
      this.paymentMethods = [];
      this.isLoadingPaymentMethod = true;
      this.errors_ = {};
      this.isEdit = true;
      this.getPaymentMethod().then(() => this.form = data);
    },
    close() {
      this.isEdit = false;
    },

    save() {
      this.errors_ = {};

      const fields = {
        site_payment_method_id: this.form.site_payment_method_id,
        payment_wallet: this.form.payment_wallet,
      };

      this.isLoading = true;

      this.$store
        .dispatch('saveProfilePaymentMethod', fields)
        .then(() => {
          this.$alert.success(this.$t('profile.success.saved'));
          this.errors_ = {};
          this.isEdit = false;
        })
        .catch((err) => {
          const errors = err.response.data.errors;

          if (Object.keys(errors).length) {
            this.errors_ = errors;
          } else {
            this.$alert.fail(this.$t('profile.errors.incomplete_profile'));
          }
        }).finally(() => this.isLoading = false);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 13px;
  font-weight: 600;
  line-height: normal;
  color: var(--charcoal);
  text-transform: uppercase;
}

.form-error {
  font-size: 12px;
  top: -5px;
  position: relative;
}

.modal .modal-footer .btn {
  min-width: 74px!important;
}
</style>
